import { Button } from '@material-ui/core';
import { Theme } from '@material-ui/core/styles';
import { makeStyles } from '@material-ui/styles';
import React, { ReactElement, ReactNode } from 'react';

import Space from '@/components/layout/Space';

const useStyles = makeStyles((theme: Theme) => ({
  container: {
    borderRadius: 10,
    padding: 2,
    backgroundColor: theme.colors.light,
    color: theme.colors.primary,
  },
  selectedButton: {
    border: 0,
    backgroundColor: theme.colors.light,
    borderColor: theme.colors.light,
    color: theme.colors.primary,
  },
  disabledButton: {
    borderRadius: 8,
    color: `${theme.colors.primary} !important`,
    border: `${theme.colors.primaryBackground} !important`,
    background: `${theme.colors.primaryBackground} !important`,
  },
}));

interface OptionRowSelectionProps<T> {
  options: {
    type: T;
    label: ReactNode;
  }[];
  onSelect: (value: T) => Promise<void> | void;
  value: T;
}

const OptionRowSelection = <T extends string>({
  options,
  onSelect,
  value,
}: OptionRowSelectionProps<T>): ReactElement => {
  const classes = useStyles();
  return (
    <Space size={0} className={classes.container}>
      {options.map(({ type, label }) => (
        <Button
          className={value !== type ? classes.selectedButton : classes.disabledButton}
          disabled={value === type}
          {...(value !== type ? { onClick: (): Promise<void> | void => onSelect(type) } : {})}
          key={type}
        >
          {label}
        </Button>
      ))}
    </Space>
  );
};

export default OptionRowSelection;
